/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { PrfDelIndexTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const prfDelIndexResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  toStorageBinOptions: INITIAL_STATE.toStorageBinOptions,
  toStorageBinOption: INITIAL_STATE.toStorageBinOption
});

export const prfDelIndexFetchPrfDelIndexLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const prfDelIndexFetchPrfDelIndexSuccess = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const prfDelIndexAddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const prfDelIndexRemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const prfDelIndexSetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const prfDelIndexWorkspaceLoading = (state, { boolean }) => ({
  ...state,
  workspaceIsLoading: boolean
});

export const prfDelIndexResetPrfDelSync01Success = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [PrfDelIndexTypes.PRF_DEL_INDEX_RESET_TIMESTAMP]: prfDelIndexResetTimestamp,
  [PrfDelIndexTypes.PRF_DEL_INDEX_FETCH_PRF_DEL_INDEX_LOADING]: prfDelIndexFetchPrfDelIndexLoading,
  [PrfDelIndexTypes.PRF_DEL_INDEX_FETCH_PRF_DEL_INDEX_SUCCESS]: prfDelIndexFetchPrfDelIndexSuccess,
  [PrfDelIndexTypes.PRF_DEL_INDEX_ADD_SELECTED_DOCUMENTS]: prfDelIndexAddSelectedDocuments,
  [PrfDelIndexTypes.PRF_DEL_INDEX_REMOVE_SELECTED_DOCUMENTS]: prfDelIndexRemoveSelectedDocuments,
  [PrfDelIndexTypes.PRF_DEL_INDEX_SET_WORKSPACE_VISIBLE]: prfDelIndexSetWorkspaceVisible,
  [PrfDelIndexTypes.PRF_DEL_INDEX_WORKSPACE_LOADING]: prfDelIndexWorkspaceLoading,
  [PrfDelIndexTypes.PRF_DEL_INDEX_RESET_PRF_DEL_SYNC01_SUCCESS]: prfDelIndexResetPrfDelSync01Success
});
